import React from "react";
import Footer, { FooterProps } from "./Footer";
import styled from "styled-components/macro";
import PageRipSVG from "images/page-rip.svg";
import { theme } from "ui/theme";

const $FooterWrapper = styled.div`
  background-color: ${theme.ColorSneaker100};
  position: relative;
  margin-top: 4rem;

  &.transparent {
    background-color: transparent;
    &::before {
      display: none;
    }
  }

  &::before {
    display: block;
    content: "";
    position: absolute;
    height: 3.5rem;
    top: -3rem;
    left: 0;
    right: 0;
    background-image: url(${PageRipSVG});
    background-repeat: repeat-x;
    z-index: 1;
  }
`;

type StylizedFooterProps = Pick<FooterProps, "userType" | "includeSignOut"> & {
  transparent?: boolean;
  children: React.ReactNode;
};

// This component is a variation of the default footer component.
// The default footer is part of the layout, but some pages
// (mainly sign-in and onboarding pages) have slightly different designs
// that include the paper rip texture and a link to introduction videos.
// These pages hide the default footer, and use this component as drop-in
// replacement instead.
export function StylizedFooter(props: StylizedFooterProps) {
  return (
    <$FooterWrapper className={props.transparent ? "transparent" : ""}>
      {props.children}
      <Footer {...props} />
    </$FooterWrapper>
  );
}
